// extracted by mini-css-extract-plugin
module.exports = {"root":"Display_root__kPcrk","innerWrapper":"Display_innerWrapper__qfqH_","screen":"Display_screen__1_ulN","text":"Display_text__2bxM2"};